import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { usePost } from "seed/api";
import View from "components/util/schema_form/fields/smart_text/SmartText.view";
import l from "components/util/l";


function SmartText({
  name,
  label,
  type,
  value,
  required,
  hidden,
  disabled,
  multiple,
  caption,
  objective = "",
  examples,
  depth = 5,
  helpMessage,
  placeholder,
  enableComments,
  values,
  dataReqs,
  appId,
  actionId,
  flowId,
  nodeId,
  executionId,
  setFieldValue,
  input,
  sectionIdx,
  defaultValue,
}) {

  const [schema, setSchema] = useState([]);
  const [schemaValues, setSchemaValues] = useState({});

  const [callGeneratedSchema, reqCallGeneratedSchema] = usePost("/apps/forms/generate_schema_form_from_prompt", {
    onCompleted: (data) => {
      setSchema(data?.schema ?? schema);
      setFieldValue(name, data?.schema ?? schema);
    },
    onError: (error) => {
      swal("Error", l("Error al generar las preguntas, intente de nuevo mas tarde%SC145"), "error");
    }
  });


  useEffect(() => {
    callGeneratedSchema({
      objective: objective,
      examples: examples,
      depth: depth
    });
  }, []);

  const onClickSubmit = (values) => {
    setSchemaValues(values);
    callGeneratedSchema({
      objective: objective,
      depth: depth,
      examples: examples,
      schema: schema,
      values: schemaValues,
    });
  }


  const isLoading = reqCallGeneratedSchema.loading; 


  return (
    <View
      schema={schema}
      schemaValues={schemaValues}
      flowId={flowId}
      nodeId={nodeId}
      dataReqs={dataReqs} 
      isLoading={isLoading}
      onClickSubmit={onClickSubmit}
    />
  )
}



export default SmartText;